import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param resourceId
 * @param poId
 */
class ResourceServices {
    /**
     *
     * @param {*} payload
     * @return
     */
    createResource = async (payload) => {
      const resource = await Helpers.post({
        url: Constants.RESOURCE,
        data: payload,
      });
      return resource;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
     updateResource = async (payload) => {
       const resource = await Helpers.put({
         url: Constants.RESOURCE,
         data: payload,
       });
       return resource;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
     updateResourceStatus = async (payload) => {
       const po = await Helpers.put({
         url: Constants.RESOURCE_STATUS,
         data: payload,
       });
       return po;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
        updateResourceWorkflowStep = async (payload) => {
          const resource = await Helpers.post({
            url: Constants.RESOURCE_WORKFLOW,
            data: payload,
          });
          return resource;
        }

        /**
         * @param resourceId
         * @param {*} payload
         * @return
         */
      deleteResource = async (payload) => {
        const resource = await Helpers.delete({
          url: Constants.RESOURCE,
          data: payload,
        });
        return resource;
      }

      /**
       * @param {*} orgId
       * @return
       */
    getResource = async (orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus) => {
      let url = `${Constants.RESOURCE}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (resourceType) url += `type=${resourceType}&`;
      if (resourceStatus) url += `status=${resourceStatus}&`;
      const resource = await Helpers.get({ url });

      return resource;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
    createResourceGroup = async (payload) => {
      const resourceGroup = await Helpers.post({
        url: `${Constants.RESOURCE}/group`,
        data: payload,
      });
      return resourceGroup;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
     updateResourceGroup = async (payload) => {
       const resourceGroup = await Helpers.put({
         url: `${Constants.RESOURCE}/group`,
         data: payload,
       });
       return resourceGroup;
     }

     /**
         * @param resourceGroupId
         * @param {*} payload
         * @return
         */
           deleteResourceGroup = async (payload) => {
             const resourceGroup = await Helpers.delete({
               url: `${Constants.RESOURCE}/group`,
               data: payload,
             });
             return resourceGroup;
           }

        /**
       * @param {*} orgId
       * @return
       */
        getResourceGroup = async (orgId) => {
          let url = `${Constants.RESOURCE}/group?`;
          if (orgId) url += `org_id=${orgId}&`;
          const resourceGroup = await Helpers.get({ url });

          return resourceGroup;
        }
}
export default new ResourceServices();
